import React from "react";
import * as style from "./style.mod.scss";
import Image from "components/image";

const ThreeRows = ({ content }) => {

  return (
    <>
      {(content?.title || content?.serviceInfos) &&
        <div
          style={{ backgroundColor: content?.bgColor && content?.bgColor?.hex }}
          className={style.threeRows}>
          <p style={{ color: content?.textColor && content?.textColor?.hex }} className={style.mainTitle}>{content?.title}</p>
          <div className={style.serviceContainer}>
            {content?.serviceInfos?.map((data, i) => (
              <div className={style.serviceSingleBox} key={i}>
                <div className={style.serviceImage}>
                  <Image image={data?.serviceIcon} alt={data?.serviceIcon?.alt} />
                </div>
                <p style={{ color: content?.textColor && content?.textColor?.hex }} className={style.serviceTitle}>{data?.serviceTitle}</p>
                <p style={{ color: content?.textColor && content?.textColor?.hex }} className={style.serviceDesc}>{data?.moreDetails}</p>
              </div>
            )
            )}
          </div>
        </div>
      }
    </>
  );
};

export default ThreeRows;